import React from 'react'
import { string, number, bool, func, oneOfType } from 'prop-types'

const Radio = ({
  label,
  value,
  name,
  handleChange,
  checked,
  className,
  ariaLabel,
}) => (
  <label className={className ? `radio ${className}` : 'radio'}>
    {label}
    <input
      type="radio"
      value={value}
      name={name}
      checked={checked}
      onChange={() => handleChange(value)}
      aria-label={ariaLabel || label}
    />
    <span className="checkmark" />
  </label>
)

Radio.propTypes = {
  label: string,
  value: oneOfType([number, string, bool]),
  name: string,
  checked: bool,
  handleChange: func,
  className: string,
  ariaLabel: string,
}

Radio.defaultProps = {
  label: '',
  value: '',
  name: '',
  checked: false,
  handleChange: () => {},
  className: '',
  ariaLabel: null,
}

export default Radio
